import { InboxChat } from "@/app/api/chats/inbox/inbox.dto";
import { useChat } from "@/providers/chat-provider";
import { Loader2Icon } from "lucide-react";
import Image from "next/image";
import ChatItem from "../chat-item";
import PinnedChats from "../pinned-chats";

const CommunityChatsTab = () => {
	const { inbox, pinnedChatUniqueIds } = useChat();
	const { isLoading = false, isError = false, chats = [] } = inbox;

	const groupChats = chats.filter(
		(chat) => chat.type === "group" && !pinnedChatUniqueIds.includes(chat.uniqueChatId)
	);

	const desiredOrderOfGroupChats = [
		"AREA Uganda",
		"Information Management Network",
		"Blueprint: The Future of Real Estate",
		"GLOBAL PROPTECH",
		"MULTIFAMILY",
		"iOi Summit",
		"VIP PropTech Global",
		"Incognito VIP Room",
		"Big5 Global",
		"EXPO REAL",
		"ARCE",
		"BAFO GROUP GLOBAL PVT LTD",
		"Global Proptech Innovation Hive",
		"GREPA",
		"REET",
		"RESIDE SUMMIT",
		"US PropTech Council",
		"XCHANGE MLS Community",
		"AI in Proptech",
		"FREI Chat",
		"MLS Community",
		"Proptech India",
		"Proptech UK",
		"Proptech USA",
		"Real Estate Brokers & Agents",
		"VIP India",
		"International Students Accommodation Forum",
	];

	const orderMap: { [key: string]: number } = {};
	desiredOrderOfGroupChats.forEach((chat, index) => {
		orderMap[chat] = index;
	});

	const sortGroupChatsByDesiredOrder = (chats: InboxChat[]): InboxChat[] => {
		return chats.sort((a, b) => {
			const orderA = orderMap[a.name ?? ""] !== undefined ? orderMap[a.name ?? ""] : Infinity;
			const orderB = orderMap[b.name ?? ""] !== undefined ? orderMap[b.name ?? ""] : Infinity;
			return orderA - orderB;
		});
	};

	const sortedGroupChats = sortGroupChatsByDesiredOrder(groupChats);

	return (
		<div className="customized-scrollbar max-h-[calc(100vh-10.5rem)] space-y-4 overflow-y-scroll p-2">
			<div className="space-y-3">
				<PinnedChats showGroupChats />

				{isLoading ? (
					<Loader2Icon className="mx-auto h-8 w-8 animate-spin stroke-brand-primary" />
				) : isError ? (
					<span>Error</span>
				) : sortedGroupChats && sortedGroupChats.length > 0 ? (
					sortedGroupChats?.map((chat) => (
						<ChatItem
							isGroup
							logo={chat?.logo}
							key={chat.uniqueChatId}
							timestamp={chat?.timestamp}
							lastMessage={chat?.lastMessage}
							isSuggestion={chat?.suggestion}
							uniqueChatId={chat?.uniqueChatId}
							name={chat?.recipient?.name || "Group"}
							onlineUsersCount={chat?.onlineUsersCount}
						/>
					))
				) : pinnedChatUniqueIds.length === 0 ? (
					<div className="py-6 text-center">
						<Image
							src="/images/chat/empty-inbox.svg"
							alt="No chats found"
							width={652}
							height={737}
							className="mx-auto w-40 object-contain grayscale"
						/>
						<p className="mt-3 text-sm text-gray-600">No chats found</p>
					</div>
				) : null}
			</div>
		</div>
	);
};

export default CommunityChatsTab;
